import { LogEventType } from '@akin-home/amplify';
import { SendAIChatLogEvent } from '@akin-home/logging';
import { postLogEvent, PostLogEventParams } from './postLogEvent';

type Params = Omit<PostLogEventParams<SendAIChatLogEvent['data']>, 'type'>;

export const postSendAIChatLogEvent = (params: Params) =>
  postLogEvent({
    type: LogEventType.SEND_AI_CHAT,
    ...params,
  });
